"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTypesMap = exports.flatQuestionTypes = exports.QuestionTypes = exports.PREVIEW_MODE = void 0;
var types_1 = require("@nexxt/common/types");
var _ = require("lodash");
var constants_1 = require("@nexxt/common/constants");
var PREVIEW_MODE;
(function (PREVIEW_MODE) {
    PREVIEW_MODE["DISABLED"] = "DISABLED";
    PREVIEW_MODE["ENABLED"] = "ENABLED";
    PREVIEW_MODE["BROKEN"] = "BROKEN";
})(PREVIEW_MODE = exports.PREVIEW_MODE || (exports.PREVIEW_MODE = {}));
exports.QuestionTypes = (_a = {},
    _a[types_1.QTYPES_CATEGORY.STANDARD] = [
        {
            name: 'Multiple Answer',
            id: 'multiple-answer',
            value: types_1.QTYPES.MULTIPLE_CHOICE,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/multiplechoice.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Choice',
            id: 'single-answer',
            value: types_1.QTYPES.SINGLE_CHOICE,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/singlechoice.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Rating',
            id: 'rating',
            value: types_1.QTYPES.ICONS,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/icon.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Rank Order',
            id: 'rank-order',
            value: types_1.QTYPES.RANK_ORDER,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/rankorder.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Scale',
            id: 'scale',
            value: types_1.QTYPES.SCALE,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/scale.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Map',
            id: 'map',
            value: types_1.QTYPES.VECTOR_MAP,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/vectormap.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Open Ended',
            id: 'open',
            value: types_1.QTYPES.OPEN,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/openend.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: {
                enable: true,
                showCheckDemeritGibberish: true,
                showCheckDemeritUninformative: true,
                showCheckDemeritAi: true,
                showCheckDemeritDuplicate: true
            },
            smartProbe: {
                enable: true,
                showResearchContext: true,
                showTargets: true,
                showTrainedModels: true,
                showProbeToggle: true
            }
        },
        {
            name: 'Numeric',
            id: 'numeric',
            value: types_1.QTYPES.NUMERIC,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/numeric.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED
        },
        {
            name: 'Formatted Text (PII)',
            id: 'formatted_text_pii',
            value: types_1.QTYPES.PII,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/openend.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED
        },
        {
            name: 'Popup Cards',
            id: 'popup-cards',
            value: types_1.QTYPES.POPUP,
            category: types_1.QTYPES_CATEGORY.STANDARD,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/popup.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        }
    ],
    _a[types_1.QTYPES_CATEGORY.SPECIALS] = [
        {
            name: 'Video Annotation',
            id: 'video-annotation',
            value: types_1.QTYPES.VIDEO_ANNOTATION,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/videoannotation.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Image Hotspot',
            id: 'hotspot',
            value: types_1.QTYPES.HOTSPOT,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/hotspot.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Tradeoff Ranking',
            id: 'idea-screener',
            value: types_1.QTYPES.TRADE_OFF,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/ideascreener.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false,
                showProbeToggleForLikeFollowUp: true,
                showProbeToggleForDislikeFollowUp: true
            }
        },
        {
            name: 'Text Highlighter',
            id: 'text-highlighter',
            value: types_1.QTYPES.TEXT_HIGHLIGHTER,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/texthighlighter.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Ad Builder',
            id: 'ad-builder',
            value: types_1.QTYPES.AD_BUILDER,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/adbuilder.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.DISABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Treeman Projective',
            id: 'treeman',
            value: types_1.QTYPES.TREEMAN,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/treeman.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false,
                showProbeToggleForLikeFollowUp: true
            }
        },
        {
            name: 'Guided Fantasy Projective',
            id: 'guided-fantasy',
            value: types_1.QTYPES.GUIDED_FANTASY,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/guidedfantasy.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Hot Air Balloon Projective',
            id: 'hot-air-balloon',
            value: types_1.QTYPES.HOT_AIR_BALLOON,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/hotairballon.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.DISABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'NPS Plus',
            id: 'nps-plus',
            value: types_1.QTYPES.NPS,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/npsplus.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Spontaneous Free Association (SFA)',
            id: 'sfa',
            value: types_1.QTYPES.SFA,
            category: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/sfa.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.DISABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Rapid Choice Question',
            id: 'rapid-choice',
            value: types_1.QTYPES.RAPID_CHOICE,
            QTYPES_CATEGORY: types_1.QTYPES_CATEGORY.SPECIALS,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/rapidchoice.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        }
    ],
    _a[types_1.QTYPES_CATEGORY.STATIC_CONTENT] = [
        // {
        //     name: 'Text Message',
        //     id: 'text',
        //     value: QTYPES.TEXT_MESSAGE,
        //     category: QTYPES_CATEGORY.STATIC_CONTENT,
        //     image: `${STATIC_STORAGE_URL}/img/portal/question-types/multimedia.png`,
        //     description: 'Last message to show user at end of survey'
        // },
        {
            name: 'Multimedia',
            id: 'multimedia',
            value: types_1.QTYPES.MULTIMEDIA,
            category: types_1.QTYPES_CATEGORY.STATIC_CONTENT,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/multimedia.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Redirect',
            id: 'departing-message',
            value: types_1.QTYPES.DEPARTING_MESSAGE,
            category: types_1.QTYPES_CATEGORY.STATIC_CONTENT,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/departing.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        }
    ],
    _a[types_1.QTYPES_CATEGORY.LOGICAL] = [
        {
            name: 'Group',
            id: 'group',
            value: types_1.QTYPES.GROUP,
            category: types_1.QTYPES_CATEGORY.LOGICAL,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/group.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.ENABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Randomizer',
            id: 'randomizer',
            value: types_1.QTYPES.RANDOMIZER,
            category: types_1.QTYPES_CATEGORY.LOGICAL,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/randomizer.png"),
            description: 'Group Randomizer',
            preview: PREVIEW_MODE.DISABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Virtual Question',
            id: 'virtual',
            value: types_1.QTYPES.VIRTUAL,
            category: types_1.QTYPES_CATEGORY.LOGICAL,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/virtualquestion.png"),
            description: 'Virtual question to set condition',
            preview: PREVIEW_MODE.DISABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        }
    ],
    _a[types_1.QTYPES_CATEGORY.BUILT_IN] = [
        {
            name: 'Greeting Text',
            id: 'greeting-text',
            value: types_1.QTYPES.GREETING_TEXT,
            category: types_1.QTYPES_CATEGORY.BUILT_IN,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/greeting.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.DISABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Departing',
            id: 'redirect-text',
            value: types_1.QTYPES.REDIRECT,
            category: types_1.QTYPES_CATEGORY.BUILT_IN,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/departing.png"),
            description: 'Last message to show user at end of survey',
            preview: PREVIEW_MODE.DISABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        },
        {
            name: 'Targets',
            id: 'targets',
            value: types_1.QTYPES.MULTI_TARGETS,
            category: types_1.QTYPES_CATEGORY.BUILT_IN,
            image: "".concat(constants_1.STATIC_STORAGE_URL, "/img/portal/question-types/virtualquestion.png"),
            description: 'Built-in question for target visualization on dashboard',
            preview: PREVIEW_MODE.DISABLED,
            qualityControlSettings: { enable: false },
            smartProbe: {
                enable: false
            }
        }
    ],
    _a);
exports.flatQuestionTypes = _.flatten(Object.values(exports.QuestionTypes));
var QuestionTypesMap = {};
exports.QuestionTypesMap = QuestionTypesMap;
_.flatten(Object.values(exports.QuestionTypes)).forEach(function (q) {
    QuestionTypesMap[q['value']] = q;
});
//# sourceMappingURL=questionTypes.js.map